import Parser from 'html-react-parser';
import l from '../../../../../lang';
import { Button } from '../../../../common/button';
import FileCheckIcon from '../../../../../assets/icons/file-check.svg?url';
import FolderExclamationIcon from '../../../../../assets/icons/folder-exclamation.svg?url';

export const Empty = ({ onAddContact }: { onAddContact: () => void }) => (
  <div className="payout_contacts_empty">
    <div className="payout_contacts_empty__icon">
      <img src={FileCheckIcon} alt="" />
    </div>
    <div className="payout_contacts_empty__title">{l('payoutContacts.empty.title')}</div>
    <div className="payout_contacts_empty__body">{l('payoutContacts.empty.body')}</div>
    <Button variant="contained" color="primary" textTransformNone onClick={onAddContact}>
      {l('payoutContacts.add')}
    </Button>
  </div>
);

export const EmptyNoFound = () => (
  <div className="payout_contacts_empty">
    <img src={FolderExclamationIcon} alt="" />
    {Parser(l('payoutContacts.empty.notFound'))}
  </div>
);
